import type ItineraryPackage from '@itinerary/ItineraryPackage';

export function useHandleEvents(pkg: ItineraryPackage, index: number) {
    const gtm = useGtm();
    const analyticsStore = useAnalyticsStore();
    const searchFormStore = useSearchFormStore();
    const currentModule = useCurrentItineraryModule();
    const authStore = useAuthStore();
    if (pkg.isTripPackage()) {
        gtm?.trackEvent({ event: 'add_to_cart' });
    }
    gtm?.trackEvent({
        event: 'srp-click reserve',
    });
    const route = useRoute();
    const searchForm = searchFormStore.currentSearchForm();
    const { searchAttributes } = searchForm;
    analyticsStore.trackAll('select', {
        isDiscounted: `${pkg.selectedPrices?.some(p => p.isDiscounted)}`,
        isFeatured: 'false',
        isSameService: `${
            pkg.reserveType === searchFormStore.firstReserveType
        }`,
        isMasir: pkg.isRoutePackage(),
        segmentServices: pkg.isTripPackage()
            ? pkg.segments.map(s => s.trips[0]?.reserveType).filter(Boolean)
            : [],
        segmentCount: pkg.isTripPackage() ? pkg.segments.length : 0,
        hasMultiLeg: pkg.hasMultiLeg,
        creationSource: authStore.siteSourceId,
        domestic: searchForm.isDomestic,
        totalCount: searchForm.totalCount,
        whiteLabel: useSiteConfigs().title,
        reserveType: searchAttributes.reserveType,
        selectedIndex: index,
        selectedSort: currentModule.value.sortBy,
        departureDate: searchAttributes.departureDateString,
        fromname: searchAttributes.from,
        toname: searchAttributes.to,
        link: `https://mrbilit.com${route.fullPath}`,
        ...(pkg.isTripPackage() && pkg.firstTrip?.corporationInfo?.title
            ? { corporationTitle: pkg.firstTrip.corporationInfo.title }
            : {}),
    });
}
